export default __webpack_public_path__ + "static/char-s-34-en-d5a5c358229e6bd49d62dda6145a5da4.webp";